import { atom } from 'jotai';
import type {
    MappedFileData,
    ParsedCSVData,
    PartialSupportResultsStatusFilters,
    RequestResultsStatus,
    ResolverJobResponse,
    SupportRequestResultsModalTableRow,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { atomWithReset } from 'jotai/utils';
import { FileWithUrl } from '@placer-ui/components';
import { SupportRequestAddressType } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/file-based-request-property/file-fields-mapping-config';

export const supportRequestOriginalFileStore = atomWithReset<FileWithUrl | undefined>(undefined);
export const resultsTableFiltersStore = atom<PartialSupportResultsStatusFilters>({});
export const resultsTableEditedStore = atom<boolean>(false);
export const mappedFileDataStore = atom<MappedFileData | undefined>(undefined);
export const supportRequestAddressTypeStore = atomWithReset<SupportRequestAddressType | undefined>(
    undefined,
);
export const parsedDataStore = atom<ParsedCSVData | undefined>(undefined);
export const statusMapStore = atom<Record<RequestResultsStatus, number> | undefined>(undefined);
export const resolverJobStore = atom<ResolverJobResponse | undefined>(undefined);
export const supportTableTagIdStore = atomWithReset<string | undefined>(undefined);
export const supportTagToUpdateStore = atom<string | undefined>(undefined);
export const supportCreateTagOpenStore = atom(false);
export const isSubmittingTableRequestsStore = atom(false);
export const deliveryETAStore = atomWithReset<string | undefined>(undefined);
export const dataForPropertySubmitStore = atomWithReset<Record<string, string | undefined>>({});
export const isUpdateTagEnabledStore = atom(false);
//TODO PLAC-63275 remove after refactor
export const tempDataTableStore = atom<SupportRequestResultsModalTableRow[] | undefined>(undefined);
